export default {
      id: "menu-usage",
      viewBox: "0 0 16 4",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#menu",
      toString: function () {
        return this.url;
      }
    }